import { openBlock as o, createElementBlock as t, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 30"
}, n = /* @__PURE__ */ e("path", {
  fill: "#6DE86A",
  d: "m1.967 14.105 9.331-11.977c.73-.937 2.098-.354 2.098.894v9.27c0 .748.536 1.354 1.198 1.354h4.538c1.031 0 1.58 1.373.9 2.247L10.7 27.871c-.73.936-2.098.353-2.098-.894v-9.27c0-.748-.536-1.354-1.198-1.354H2.866c-1.03 0-1.58-1.374-.899-2.248"
}, null, -1), r = /* @__PURE__ */ e("path", {
  stroke: "#0D141F",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m1.967 14.105 9.331-11.977c.73-.937 2.098-.354 2.098.894v9.27c0 .748.536 1.354 1.198 1.354h4.538c1.031 0 1.58 1.373.9 2.247L10.7 27.871c-.73.936-2.098.353-2.098-.894v-9.27c0-.748-.536-1.354-1.198-1.354H2.866c-1.03 0-1.58-1.374-.899-2.248"
}, null, -1), s = [
  n,
  r
];
function l(d, i) {
  return o(), t("svg", c, [...s]);
}
const _ = { render: l };
export {
  _ as default,
  l as render
};
